var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isStatusLoading
    ? _c("LoadingAnimation", { attrs: { "animation-style": "bars" } })
    : _c(
        "div",
        { staticClass: "w-100 user-modal-register-plan-select-view px-2" },
        [
          _c("div", { staticClass: "mb-4 text-center" }, [
            _c("p", { staticClass: "font-weight-bold font-size-200 mb-0" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("trans")("Choose Your Plan")) +
                  "\n        "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.plans, function (plan) {
            return _c(
              "div",
              { staticClass: "position-relative w-100" },
              [
                plan.isMostPopular
                  ? _c(
                      "div",
                      { staticClass: "most-popular-badge font-weight-bold" },
                      [
                        _c(
                          "span",
                          { staticClass: "text-white align-self-center mr-3" },
                          [
                            _vm._v(
                              " " + _vm._s(_vm._f("trans")("Most Popular"))
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "SelectBillingItem",
                  {
                    staticClass: "mb-2 border",
                    class: {
                      "radio-panel-selected-modal":
                        _vm.selectedProduct === plan.itemValue,
                      "bg-white": _vm.selectedProduct != plan.itemValue,
                      "most-popular-br-8": plan.isMostPopular,
                      "br-8": !plan.isMostPopular,
                    },
                    attrs: {
                      disabled: _vm.isSubmitting,
                      "enable-learn-more": true,
                      "learn-more-texts": plan.learnMoreTexts,
                      "plan-billing-item": true,
                      "plan-billing-item-use": plan.planBillingItemUse,
                      "plan-billing-item-credit": plan.planBillingItemCredit,
                      "price-string-monthly": plan.priceStringMonthly,
                      "item-value": plan.itemValue,
                      name: plan.name,
                      "default-styles": plan.styles,
                    },
                    on: { closeLearnmore: _vm.toggleLearnMore },
                    model: {
                      value: _vm.selectedProduct,
                      callback: function ($$v) {
                        _vm.selectedProduct = $$v
                      },
                      expression: "selectedProduct",
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "d-inline-flex flex-row flex-wrap-reverse h-100",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-inline-flex flex-column justify-content-between mr-1",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "font-weight-bold font-size-125 mb-1 ml-n2 mt-n1 d-inline-flex flex-wrap title-text",
                              },
                              [
                                _c("span", { staticClass: "ml-2_" }, [
                                  _vm._v(
                                    _vm._s(_vm._f("trans")(plan.transKey))
                                  ),
                                ]),
                                _vm._v(" "),
                                plan.isMostPopular
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "most-popular-badge-mobile",
                                      },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm._f("trans")("Most Popular")
                                            ) +
                                            "\n                        "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(plan.infoTexts, function (info) {
                              return [
                                _c("span", [
                                  info.icon
                                    ? _c("i", { staticClass: "fa fa-check" })
                                    : _c("i", [_c("CoinSVG")], 1),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "pl-1",
                                    domProps: { innerHTML: _vm._s(info.text) },
                                  }),
                                ]),
                              ]
                            }),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "learn-more-link text-underline cursor-pointer font-size-100 user-select-none white-space-nowrap position-relative",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.toggleLearnMore(plan.name)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "learn-more-link position-absolute top-0 left-0",
                                    class: { "opacity-0": !plan.showLearnMore },
                                  },
                                  [_vm._v(_vm._s(_vm._f("trans")("show less")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: { "opacity-0": plan.showLearnMore },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm._f("trans")("learn more"))
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("ButtonWithLoadingState", {
            staticClass:
              "btn btn-success btn-lg btn-block font-weight-bold text-uppercase rounded my-4",
            attrs: {
              "data-user-modal-button-submit": "",
              icon: "fa fa-arrow-right lh-1",
              text: _vm._f("trans")("Continue"),
              "is-state-loading": _vm.isSubmitting,
              "show-icon-after-text": true,
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.goToChooseBilling.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3 text-center d-flex flex-column" }, [
            _c("span", { staticClass: "mr-2_ mb-2" }, [
              _c("i", { staticClass: "far fa-check mr-1_" }),
              _vm._v(_vm._s(_vm._f("trans")("Cancel anytime"))),
            ]),
            _vm._v(" "),
            _c("span", [
              _c("i", { staticClass: "far fa-check mr-1_" }),
              _vm._v(
                _vm._s(
                  _vm._f("trans")(
                    "Two week money back guarantee, no questions asked"
                  )
                )
              ),
            ]),
          ]),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }